import { TGoogleMapsSettings } from '../types/googleMapsConfig';

export const defaultGoogleMapsSetting: TGoogleMapsSettings = {
  publicGoogleApiKey: '',
  privateGoogleApiKey: '',
};
